import { render, staticRenderFns } from "./TemplateBox.vue?vue&type=template&id=37d0b873&scoped=true&"
import script from "./TemplateBox.vue?vue&type=script&lang=js&"
export * from "./TemplateBox.vue?vue&type=script&lang=js&"
import style0 from "./TemplateBox.vue?vue&type=style&index=0&id=37d0b873&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0b873",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VContainer,VDialog,VRow,VSpacer,VStepper,VStepperContent,VStepperStep})
